import pluck from 'ramda/src/pluck'
import memoizeWith from 'ramda/src/memoizeWith'

import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc'

// keys
import { assigneeDisplayNameKey } from 'root/src/shared/constants/keys'

const responseLenses = getResponseLenses(GET_PROJECT)
const { pathOrAssignees } = responseLenses

export default memoizeWith(
	(state, props) => JSON.stringify(pathOrAssignees([1], getRecordSelector(state, props))),
	(state, props) => pluck(
		assigneeDisplayNameKey, pathOrAssignees([1], getRecordSelector(state, props)),
	),
)
